import { styled } from '@mui/material'
import { Button } from '../../../../components/buttons'
import { intl } from '../../../../../i18n'
import { useMemo } from 'react'

const CloseButton = ({
  onClick,
  disabled,
}: {
  onClick: () => void
  disabled?: boolean
}) => {
  const label = useMemo(() => intl.formatMessage({ id: 'close' }), [])
  return (
    <StyledButton
      variant="outlined"
      colorPattern="monotone"
      size="s"
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </StyledButton>
  )
}

export default CloseButton

// Style
const StyledButton = styled(Button)({
  width: '100px',
})
